<input
  [colorPicker]="value"
  [style.background]="value"
  [cpOutputFormat]="'hex'"
  [cpAlphaChannel]="'disabled'"
  [cpOKButton]="true"
  [cpOKButtonText]="'Select'"
  [cpCancelButton]="true"
  [cpCancelButtonText]="'Cancel'"
  (colorPickerChange)="onColorChange($event)"
  [formControl]="form"
  class="color-picker-input"
  readonly>

@if (!form.valid && submitted) {
  <tidy-error-message
    [text]="errorMessage" />
}